import { purify } from '@vfit/shared/themes';
import * as E from '../../editorialCard.style';
import { EditorialFrame } from '../EditorialFrame';
import { ITechAppointmentSummary } from './techAppointmentSummary.models';
import * as S from './techAppointmentSummary.style';

export const TechAppointmentSummary: React.FC<ITechAppointmentSummary> = ({
  title,
  day,
  time,
  description,
  ...rest
}) => {
  const [pDescription] = purify([description]);

  return (
    <EditorialFrame title={title} {...rest}>
      <E.Section>
        <S.Date>
          {day}
          <br />
          {time}
        </S.Date>
        {pDescription && <S.Description dangerouslySetInnerHTML={{ __html: pDescription }} />}
      </E.Section>
    </EditorialFrame>
  );
};

